<template>
  <v-radio-group :hide-details="'auto'" class="va-radio-card__group" row v-model="selected">
    <div
      @click="selectCard(item.value)"
      :class="['va-radio-card', selected === item.value ? 'va-radio-card--active' : '']"
      v-for="item in items"
      :key="item.value">
      <div class="va-radio-card__content">
        <v-radio
          :ripple="false"
          class="va-radio-card__input"
          :value="item.value"
          :label="item.label ? `${item.label}` : ''"></v-radio>
        <slot :name="item.slotName" :item="item"></slot>
      </div>
    </div>
  </v-radio-group>
</template>

<script>
  export default {
    name: "VaRadioContentCard",
    props: {
      value: {
        required: true,
        default: "",
      },
      items: {
        type: Array,
        default: () => [],
        required: true,
      },
    },
    data() {
      return {
        selected: null,
      };
    },
    beforeMount() {
      if (this.value) {
        this.selected = this.value;
      }
    },
    methods: {
      selectCard(value) {
        this.selected = value;
        this.$emit("input", value);
        this.$emit("change", value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-radio-card__group {
    margin-top: 0;
    padding-top: 0;
    &::v-deep {
      .v-input--radio-group__input {
        gap: 12px;
        .va-radio-card {
          flex: 1;
        }
      }
    }
    .va-radio-card {
      border: 1px solid get-color("border");
      border-radius: 4px;
      cursor: pointer;
      flex: none;
      flex-grow: 1;
      &:hover {
        border: 1px solid get-color("primary");
      }

      &.va-radio-card--active {
        border: 1px solid get-color("primary");
      }
      &__content {
        padding: 18px 24px;
        position: relative;
        &::v-deep {
          .va-radio-card__input {
            position: absolute;
            top: 7px;
            right: 12px;
            margin-right: 0;
            .v-input--selection-controls__input {
              margin-right: 0 !important;
              width: 20px;
            }
          }

          .v-icon {
            color: get-color("icon");
          }
        }
      }
    }
  }
</style>
